import {
  FormControl,
  Select,
  MenuItem,
  FormHelperText,
  Button,
} from "@material-ui/core";
import { useState, useRef, useEffect } from "react";
import { connect } from "react-redux";
import { findDefaultBankIndex } from ".";
import { NoteModals } from "../../../lib/NoteModals";
import { IfscModal } from "../../../lib/NoteModals/ifscModal";
import TextInput from "../../../lib/TextField";
import {
  fetchIFSCDetails,
  updateBankDetails,
} from "../../../store/actions/nct";
import { RootStateType } from "../../../store/reducers";
import { BANK, ImageSaveType } from "../../../store/types/nct";
import {
  accountNumberRegex,
  accountNumberValidation,
  validateIfsc,
  ACCOUNT_TYPE_MASTER_DATA,
  getBankAddress,
} from "../../../utils/constants";
import { ConsolidateTableRowType } from "../ConsolidationFolios/types";
import { ifscRegex } from "../CorrectionFolios/types";
import { ValidationUI } from "../MinorStatus/minor-status-edit-bank";
import { BackArrow } from "../UpdateNominee/SelectedFolios";
import { initialValues } from "../UpdateNominee/update-nominee-edit";
import en from "../../../lang/en-us";
import Image from "../../Image";

const { dashboard, common } = en;

interface BANK_ACCOUNT_DETAILS extends BANK {
  amcName: string;
  primaryHolder: string;
  folioNo?: string;
}

type ACCOUNT_DETAILS = {
  key: string;
  label: string;
  value: string;
  onBlurFunction?: Function;
  isDisabled: boolean;
  fieldValidation?: Function;
  shouldValidateField?: boolean;
};

function ChangeBankSelected(props: any) {
  const { targetFunds } = props.location.state || {};
  const [bankDetails, setDetails] = useState<BANK_ACCOUNT_DETAILS[]>([]);
  const [newBankDetails, setNewDetails] = useState({
    accountNo: "",
    ifsc: "",
    name: "",
    accountType: "SAVINGS",
    branch: "",
    city: "",
    pincode: "",
  });
  const [errors, setErrors] = useState<any>({});
  const [modalData, setShowModal] = useState<any>(initialValues);
  const [cheques, setCheques] = useState<any>({
    oldCheque: { name: "OldCheque", format: "", content: "" },
    newCheque: { name: "NewCheque", format: "", content: "" },
  });
  const [showAlertModal, setAlertModal] = useState<{
    deleteType: string;
    showModal: boolean;
  }>({
    deleteType: "",
    showModal: false,
  });
  const folioRef = useRef<string>();

  const [showLoader, setLoader] = useState<boolean>(false);
  const [ifscValidation, setValidation] = useState<boolean>(false);

  useEffect(() => {
    if (!props.location.state) {
      props.history.push("/");
      return;
    }
    const { targetFunds } = props.location.state || {};
    setDetails(
      targetFunds.map((_ele: ConsolidateTableRowType) => {
        const validBankIndex = findDefaultBankIndex(_ele);
        return {
          amcName: _ele.amcName,
          primaryHolder: _ele.investorName,
          folioNo: _ele.folio,
          ..._ele.banks[validBankIndex],
        };
      })
    );
  }, []);

  useEffect(() => {
    const { ifsc } = newBankDetails;
    setLoader(false);
    if (ifsc.length === 11) {
      document.getElementById("ifsc")?.blur();
      _getIFSCDetails();
    } else {
      setNewDetails({
        ...newBankDetails,
        name: "",
        branch: "",
        city: "",
        pincode: "",
      });
    }
  }, [newBankDetails.ifsc]);

  const handleRemoveBankDetails = (index: number) => {
    const filteredData = bankDetails.filter(
      (_ele: BANK_ACCOUNT_DETAILS, ind: number) =>
        ind !== Number(folioRef.current)
    );
    setAlertModal({
      showModal: false,
      deleteType: "",
    });
    if (filteredData.length === 0) {
      setAlertModal({
        deleteType: "deletedAllFolios",
        showModal: true,
      });

      return;
    }
    setDetails(filteredData);
  };

  const _handleTextInputChange = (key: string, value: any) => {
    setNewDetails({
      ...newBankDetails,
      [key]: value,
    });
  };

  const validateForm = () => {
    let validForm: boolean = true;
    let errors: any = {};
    if (!accountNumberRegex.test(newBankDetails.accountNo)) {
      validForm = false;
      errors["accountNo"] = common.errors.bankErrors.accountNo.regexError;
    }
    if (
      newBankDetails.accountType ===
      dashboard.ChangeBank.selectedFolios.fields.accountType
    ) {
      errors["accountType"] = common.errors.bankErrors.accountType;
      validForm = false;
    }
    setErrors(errors);
    return validForm;
  };

  const handleSubmit = async () => {
    if (validateForm()) {
      const { targetFunds } = props.location.state;
      const pan = props.investorData.PAN;
      const [fund] = targetFunds;
      const { banks } = fund;
      const [bankData] = banks;
      const { accountNo: sourceAccountNo, ifsc: sourceIFSC } = bankData;
      const { accountNo: targetAccountNo, ifsc: targetIFSC } = newBankDetails;
      if (sourceAccountNo === targetAccountNo) {
        setNewDetails({
          ...newBankDetails,
          accountNo: "",
          ifsc: "",
          name: "",
          branch: "",
          city: "",
          pincode: "",
        });
        alert(common.errors.bankErrors.sameBankDetails);
        return;
      }
      const data = targetFunds.map((_ele: ConsolidateTableRowType) => ({
        amc: _ele.amc,
        amc_name: _ele.amcName,
        folio: String(_ele.folio),
        bankDetails: {
          ...newBankDetails,
        },
      }));
      let payload = {
        email: targetFunds[0].email,
        mobile: targetFunds[0].mobile,
        distributor_id: props.token,
        pan,
        data,
      };
      console.log("Data for change Bank", payload);
      try {
        let res = await props.updateBankDetails(payload);
        if (res.status === 201) {
          props.history.replace("/new-transaction/nct-type/success", {
            state: {
              succesMessage: res.message,
            },
          });
        }
      } catch (err: any) {
        alert(err.message || err);
      }
    }
  };

  const _handleChangeBankDetails = (
    resetValues: boolean = false,
    showModal: boolean = false,
    bankName: string = "",
    bankAddress: string = "",
    city: string = "",
    pincode: string = ""
  ) => {
    setShowModal({
      showModal: showModal,
      name: bankName,
      branch: bankAddress,
      city: city,
      pincode: pincode,
    });
    if (resetValues) {
      setNewDetails({
        ...newBankDetails,
        name: "",
        branch: "",
        city: "",
        pincode: "",
      });
    }
  };

  const _getIFSCDetails = async () => {
    if (newBankDetails.ifsc.match(ifscRegex)) {
      setValidation(true);
      setLoader(true);
      const { pan, pekrn, mobile, reqId } = props;
      try {
        let response: any = await props.fetchIFSCDetails({
          pan,
          pekrn,
          mobile,
          reqId,
          ifscCode: newBankDetails.ifsc,
        });
        const { errors = [], data = [] } = response;
        if (errors.length) {
          const [firstError] = errors;
          throw Error(firstError?.message);
        }
        const [details] = data;
        const {
          BankAdd1 = "",
          BankAdd2 = "",
          BankAdd3 = "",
          BankPin = "",
        } = details;
        _handleChangeBankDetails(
          false,
          true,
          details.BankName,
          getBankAddress(BankAdd1, BankAdd2, BankAdd3),
          details.BankCity,
          String(BankPin)
        );
        setValidation(false);
      } catch (e: any) {
        setLoader(false);
        setValidation(false);
        _handleChangeBankDetails(true);
        setErrors({ ifsc: e.message });
      }
    }
  };

  const validateIfscWithRegex = (value: string) => {
    if (!value.match(ifscRegex)) {
      setLoader(false);
      setValidation(false);
      _handleChangeBankDetails(true);
      setErrors({ ifsc: common.errors.bankErrors.ifsc.regex });
    }
  };

  const _getBankInfo = () => {
    const { name = "", branch = "", city = "" } = modalData;
    return [name, branch, city].join(",");
  };

  const _handleProceed = () => {
    const { name = "", branch = "", city = "", pincode = "" } = modalData;
    setNewDetails({
      ...newBankDetails,
      name,
      branch,
      city,
      pincode,
    });
    setShowModal(initialValues);
  };

  const _handleModalClose = () => {
    setShowModal(false);
    setNewDetails({
      ...newBankDetails,
      ifsc: "",
      name: "",
      branch: "",
      city: "",
      pincode: "",
    });
  };

  return (
    <div className="curved-bg">
      <BackArrow history={props.history} />
      <div className="curved-bg-content update-pan-selected-content">
        <h5 style={{ marginLeft: "10px" }}>Change of Bank Account Details</h5>
        <div className="curved-bg-content-inner">
          <div
            className="curved-bg-content-inner-top"
            style={{
              minHeight: "auto",
            }}
          >
            <p>{dashboard.ChangeBank.selectedFolios.subheading}</p>
            {bankDetails.map((_ele: BANK_ACCOUNT_DETAILS, ind: number) => (
              <div className="selected-folios-list">
                <h3>{_ele.amcName}</h3>
                <a className="delete-folio">
                  <Image
                    src="/images/delete-folio.svg"
                    alt="delete icon"
                    onClick={() => {
                      folioRef.current = ind.toString();
                      setAlertModal({
                        deleteType: "deleteFolio",
                        showModal: true,
                      });
                    }}
                  />
                </a>
                <div className="selected-folios-list-bottom">
                  <p>
                    {dashboard.ChangeBank.selectedFolios.primaryHolder}
                    <span>{_ele.primaryHolder}</span>
                  </p>
                  <p>
                    {dashboard.ChangeBank.selectedFolios.ifsc}
                    <span>{_ele.ifsc || _ele.neftIfsc}</span>
                  </p>
                  <p>
                    {dashboard.ChangeBank.selectedFolios.accountNo}
                    <span>{_ele.accountNo}</span>
                  </p>
                  <p>
                    {dashboard.ChangeBank.selectedFolios.folioNo}
                    <span>{_ele.folioNo}</span>
                  </p>
                </div>
              </div>
            ))}
          </div>
          <div className="add-new-bankAccount">
            <h4>{dashboard.ChangeBank.selectedFolios.addNewBankHeading}</h4>
            <p>{dashboard.ChangeBank.selectedFolios.addNewBankHeadingInfo}</p>
            <div className="new-bank-fields change-bank-selected-fields">
              {[
                {
                  key: "accountNo",
                  label:
                    dashboard.ChangeBank.selectedFolios.fields.accountNumber,
                  value: newBankDetails.accountNo,
                  isDisabled: false,
                  fieldValidation: accountNumberValidation,
                },
                {
                  key: "ifsc",
                  label: dashboard.ChangeBank.selectedFolios.fields.ifsc,
                  value: newBankDetails.ifsc,
                  onBlurFunction: validateIfscWithRegex,
                  isDisabled: false,
                  shouldValidateField: true,
                  fieldValidation: validateIfsc,
                },
                {
                  key: "name",
                  label: dashboard.ChangeBank.selectedFolios.fields.bankName,
                  value: newBankDetails.name,
                  isDisabled: true,
                },
                {
                  key: "accountType",
                  label: dashboard.ChangeBank.selectedFolios.fields.accountType,
                  value:
                    newBankDetails.accountType ||
                    dashboard.ChangeBank.selectedFolios.fields.accountType,
                  isDisabled: false,
                },
                {
                  key: "branch",
                  label: dashboard.ChangeBank.selectedFolios.fields.branch,
                  value: newBankDetails.branch,
                  isDisabled: true,
                },
                {
                  key: "city",
                  label: dashboard.ChangeBank.selectedFolios.fields.city,
                  value: newBankDetails.city,
                  isDisabled: true,
                },
              ].map((_ele: ACCOUNT_DETAILS) =>
                _ele.key === "accountType" ? (
                  <FormControl variant="outlined" error={!!errors[_ele.key]}>
                    <Select
                      labelId="portfolio-sortby-label"
                      id="portfolio-sortby"
                      name={"accountType"}
                      value={_ele.value}
                      onChange={(e) => {
                        _handleTextInputChange(_ele.key, e.target.value);
                      }}
                      // readOnly={true}
                    >
                      <MenuItem value={_ele.label}>{_ele.label}</MenuItem>
                      {ACCOUNT_TYPE_MASTER_DATA.map((type: string) => (
                        <MenuItem value={type}>{type}</MenuItem>
                      ))}
                    </Select>
                    <FormHelperText
                      className={!!errors[_ele.key] ? "error" : ""}
                    >
                      {errors[_ele.key]}
                    </FormHelperText>
                  </FormControl>
                ) : (
                  <FormControl variant="outlined">
                    <TextInput
                      variant="outlined"
                      label={_ele.label}
                      value={_ele.value.toUpperCase()}
                      name={_ele.key}
                      id={_ele.key}
                      onChange={(e: any) => {
                        if (_ele.fieldValidation) {
                          if (_ele.fieldValidation(e.target.value)) {
                            _handleTextInputChange(_ele.key, e.target.value);
                          }
                          return;
                        }
                        _handleTextInputChange(_ele.key, e.target.value);
                      }}
                      onFocus={() => setErrors({})}
                      error={!!errors[_ele.key]}
                      onBlur={() => {
                        if (_ele.onBlurFunction) {
                          _ele.onBlurFunction(_ele.value);
                        }
                      }}
                      helperText={errors[_ele.key]}
                      disabled={_ele.isDisabled}
                      title={!!_ele.isDisabled ? _ele.value : ""}
                    />
                    {_ele.shouldValidateField && showLoader && (
                      <FormHelperText>
                        <ValidationUI
                          isValidating={ifscValidation}
                          onValidationText={common.validatingIFSC}
                          successfulValidationText={common.IFSCValidated}
                        />
                      </FormHelperText>
                    )}
                  </FormControl>
                )
              )}
            </div>
          </div>
          <div className="curved-bg-content-inner-bottom">
            {/* <h4>{dashboard.ChangeBank.selectedFolios.uploadDocuments}</h4> */}
            {/* <p>{dashboard.ChangeBank.selectedFolios.uploadDocumentsInfo}</p> */}
            <div className="selected-folios-btn bank-selected-folios-bottom">
              <div className="change-bank-upload">
                <div className="change-bank-upload-inner">
                  <div className="change-bank-upload-single">
                    {/* <p>{dashboard.ChangeBank.selectedFolios.cancelledCheque}</p> */}
                    <div className="bank-selected-upload-fields">
                      {/* <UploadFile */}
                      {/*   onImageSelected={(value: any, format: any) => { */}
                      {/*     setCheques({ */}
                      {/*       ...cheques, */}
                      {/*       oldCheque: { */}
                      {/*         ...cheques.oldCheque, */}
                      {/*         format: format, */}
                      {/*         content: value, */}
                      {/*       }, */}
                      {/*     }); */}
                      {/*   }} */}
                      {/*   id={"oldCheque"} */}
                      {/* /> */}
                    </div>
                  </div>
                  <div className="change-bank-upload-single">
                    {/* <p>{dashboard.ChangeBank.selectedFolios.bankCheque}</p> */}
                    <div className="bank-selected-upload-fields">
                      {/* <UploadFile */}
                      {/*   onImageSelected={(value: any, format: any) => { */}
                      {/*     setCheques({ */}
                      {/*       ...cheques, */}
                      {/*       newCheque: { */}
                      {/*         ...cheques.newCheque, */}
                      {/*         format: format, */}
                      {/*         content: value, */}
                      {/*       }, */}
                      {/*     }); */}
                      {/*   }} */}
                      {/*   id={"newCheque"} */}
                      {/* /> */}
                    </div>
                  </div>
                </div>
                {/* <FaqLink */}
                {/*   section={BANK_ACCOUNT_DETAILS} */}
                {/*   history={props.history} */}
                {/* /> */}
                <Button
                  className="customBtn"
                  disabled={
                    !Object.values(newBankDetails).every((_ele) => !!_ele)
                  }
                  onClick={handleSubmit}
                >
                  {dashboard.ChangeBank.selectedFolios.buttonText}
                </Button>
                {modalData.showModal && (
                  <IfscModal
                    extraClass="ifsc-modal"
                    showModal={modalData.showModal}
                    heading={dashboard.UpdateIFSC.noteModals.pleaseConfirm}
                    info1={dashboard.UpdateIFSC.noteModals.bankName}
                    info2={dashboard.UpdateIFSC.noteModals.ifscCode}
                    info3={dashboard.UpdateIFSC.noteModals.city}
                    info4={dashboard.UpdateIFSC.noteModals.branch}
                    content1={modalData.name}
                    content2={newBankDetails.ifsc}
                    content3={modalData.city}
                    content4={modalData.branch}
                    proceedBtn={dashboard.UpdateIFSC.noteModals.proceedText}
                    onProceed={_handleProceed}
                    cancelBtn={dashboard.UpdateIFSC.noteModals.cancelText}
                    onCancel={_handleModalClose}
                  />
                )}
                <NoteModals
                  showModal={showAlertModal.showModal}
                  heading={dashboard.noteModals.nctModal.heading}
                  info={
                    showAlertModal.deleteType === "deletedAllFolios"
                      ? dashboard.noteModals.bank.info
                      : dashboard.ChangeTaxStatus.noteModals.confirmationText
                  }
                  proceedBtn={
                    showAlertModal.deleteType === "deletedAllFolios"
                      ? dashboard.noteModals.okayTxt
                      : dashboard.noteModals.otpModal.proceedText
                  }
                  cancelBtn={
                    showAlertModal.deleteType === "deletedAllFolios"
                      ? ""
                      : dashboard.noteModals.otpModal.cancelText
                  }
                  onProceed={
                    showAlertModal.deleteType === "deletedAllFolios"
                      ? () => props.history.goBack()
                      : handleRemoveBankDetails
                  }
                  onCancel={() => {
                    setAlertModal({
                      deleteType: "",
                      showModal: false,
                    });
                    folioRef.current = "";
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default connect(
  ({ authReducer }: RootStateType) => ({ ...authReducer }),
  {
    fetchIFSCDetails,
    updateBankDetails,
  }
)(ChangeBankSelected);
